import axios from "axios";

export const getHarvestLeaderboard = async () => {
  return axios.get(
    "https://bipfwudnwwrbfdqyokvt.functions.supabase.co/harvest-stats"
  );
};
